import React, { Component } from "react";
import QrReader from "react-qr-reader";
import { removeElementFromArray } from "../oro-module/commonFunctions";
// import Webcam from "react-webcam";

const convertAADHAARData = (data) => {
  // yob: "1984"

  let dn = data.name.split(" ");
  let aadhaarORO = {
    aadhaar_number: data.uid,
    gender: data.gender === 'M' ? "male" : data.gender === 'F' ? "female" : "other",
    first_name: dn[0],
    last_name: dn[dn.length - 1],
    middle_name: dn.length === 3 ? dn[1] : "",
    permanent_pin: data.pc,
    permanent_address_1: data.co,
    permanent_address_2: data.house,
    permanent_address_3: data.lm,
    permanent_area: data.loc,
    permanent_state: data.state,
    permanent_district: data.dist,
    permanent_taluka: data.vtc,
    full_name_display: data.name,
    customer_type: data.gender && ['M', 'F', 'O'].indexOf(data.gender) !== -1 ? 'individual' : ''
  };
  return aadhaarORO;
}

class QRCodeScanner extends Component {
  constructor(props) {
    super(props);
    // this.handleChange = this.handleChange.bind(this);
    this.state = {
      ttid: "TTID" + String(Math.round(Math.random() * 1000000000)),
      ttid2: "TTID" + String(Math.round(Math.random() * 1000000000)) + 1,
      delay: 500,
      result: "No result"
    };
  }
  generateID() {
    return this.state.ttid;
  }
  generateID2() {
    return this.state.ttid2;
  }

  handleScan=(data)=> {
    let { dataType, onScan, onScanComplete } = this.props.component;
    if (data) {
      this.setState({
        result: data
      });
      this.props.liftState(this.props.component, this.state.result);

      if (dataType === "aadhaar" && data != null) {
        let axml = data.split(/PrintLetterBarcodeData /)[1].split('<')[0];
        let alldata = axml.replace('/>', ' ');
        var g = alldata.split('" ');
        var qrobj = {};
        for (var i = 0; i < g.length; i++) {
          var x = g[i].split('="');
          qrobj[x[0]] = x[1]
        }

        let aadhaarORO = convertAADHAARData(qrobj);
        switch (onScan) {
          case 'fillData':
            for (var key in aadhaarORO) {
              this.props.liftState({ name: key }, aadhaarORO[key]);
            }
            if (onScanComplete) {
              if(onScanComplete.action=='closemodal'){
                const { opensimplemodals } = this.props.parentState;
                let newModals = removeElementFromArray({ arr: opensimplemodals, elem: onScanComplete.value });
                this.props.liftGlobalState({ name: 'opensimplemodals' }, newModals);
              }
            }
            break;
        }
        console.log(qrobj)


        // obj.acno = alldata.split('acno="')[1].split('"')[0];
        // obj.name = alldata.split('receipt="')[1].split('"')[0]
        // obj.gender=alldata.split('CIN="')[1].split('"')[0];
        // obj.co=alldata.split('co="')[1].split('"')[0];
        // obj.gender=alldata.split('CIN="')[1].split('"')[0];
        // obj.house=alldata.split('house="')[1].split('"')[0];
        // obj.loc=alldata.split('loc="')[1].split('"')[0];
        // obj.vtc=alldata.split('vtc="')[1].split('"')[0];
        // obj.dist=alldata.split('dist="')[1].split('"')[0];
        // obj.state=alldata.split('state="')[1].split('"')[0];
        // obj.pin=alldata.split('pc="')[1].split('"')[0];
        // obj.dob=alldata.split('dob="')[1].split('"')[0];

      } else if (this.props.component.dataType == "FD" && data != null) {
        // acno, receipt no, CIN, name, amount, int rate, opening date, maturity date, period months, period days. String is separated by .
        // <?xml version="1.0" encoding="UTF-8"?> <PrintLetterBarcodeData acno="380040395089" receipt="Amrutraj Shrikant Gore" CIN="M" name="1984" co="S/O Shrikant Gore" house="Gore Hospital" loc="Manthale Nagar" vtc="Latur" dist="Latur" state="Maharashtra" pc="413512" dob="24/03/1984"/>
        let axml = data.split(/PrintLetterBarcodeData /)[1].split('<')[0];
        let alldata = axml.replace('/>', ' ');
        var g = alldata.split('" ');
        var qrobj = {};
        for (var i = 0; i < g.length; i++) {
          var x = g[i].split('="');
          qrobj[x[0]] = x[1]

        }

        console.log(qrobj)
      }
    }
  }
  handleError(err) {
    console.error(err);
  }

  componentDidMount() {
    if (
      this.props.parentState.pageData &&
      !this.props.parentState.pageData[this.props.component.name] &&
      this.props.component.default
    ) {
      this.props.liftState(this.props.component, this.props.component.default);
    }
  }

  render() {
    const {
      name,
      previewStyle
    } = this.props.component;

    let boxvalue = this.props.parentState.pageData[name]
      ? this.props.parentState.pageData[name]
      : this.state.result;

    return (
      <div>
        <QrReader
          delay={this.state.delay}
          style={previewStyle}
          onError={this.handleError}
          onScan={this.handleScan}
          name={name}
          value={boxvalue}
        />
      </div>
    );
  }
}

export default QRCodeScanner;